
    import '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-chat/deepSeek.md?watch=parent';
    export const toc = [{"id":"zh-cn","depth":2,"title":"zh-CN"},{"id":"en-us","depth":2,"title":"en-US"}];
export const frontmatter = {"title":"Deep Seek","toc":"menu","filename":"docs/x-sdk/demos/x-chat/deepSeek.md","lastUpdated":1758693184000,"description":"接入云服务平台，可发送消息、处理数据、终止消息。"};